import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from 'Shared/Header';
import AddNewPanier from './AddNewPanier';

export const formatDate = (date) => [date.getMonth() + 1, date.getDate(), date.getFullYear()].join('-');
export const formatAmount = (amount = 0, fraction = 0) => {
  const result = Number(amount).toLocaleString('de-DE', {
    style: 'currency',
    currency: 'MDH',
    minimumFractionDigits: fraction,
  });
  return result.split('MDH')[0];
};

const Footer = () => (
  <Box sx={{
    backgroundColor: '#F8F9FA', border: '1.5px solid #E2E8F0', py: 2, textAlign: 'center',
  }}
  >
    <Typography sx={{ color: '#8397AE', fontSize: '14px' }}>
      {`COPIMA ${new Date().getFullYear()} © - Tous droits resérvés`}
    </Typography>
  </Box>
);
const NO_SUB_HEADER = ['/', '/cart', '/media', '/account', '/catalog', '/orders', '/dashboard', '/account-settings', '/reglements', '/factures', '/users', '/announcements'];
const isNoSubHeader = (pathname) => (
  NO_SUB_HEADER.includes(pathname) || pathname.startsWith('/reglements/') || pathname.startsWith('/factures/') || pathname.startsWith('/orders/') || pathname.startsWith('/cart/') || pathname.startsWith('/products/')
);
const Layout = ({ children }) => {
  const { pathname } = useLocation();
  // const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const [h, setH] = useState(70);
  useEffect(() => {
    setH(isNoSubHeader(pathname) ? 70 : 100);
  }, [pathname]);
  return (
    <>
      <Header />
      <>
        <AddNewPanier />
        <Box
          sx={{
            backgroundColor: '#F8FAFC',
            zIndex: 1,
            pt: { md: `${h}px`, xs: 0 },
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
          }}
        >
          <Box sx={{
            pl: { xs: 0, md: isNoSubHeader(pathname) ? 0 : 17 },
            pr: { xs: 0, md: isNoSubHeader(pathname) ? 0 : 17 },
            flex: 1,
          }}
          >
            {children}
          </Box>
          <Footer />
        </Box>
      </>
    </>
  );
};

export default Layout;
